// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profileTitle {
    font-weight: 500;
}

.status-text-success {
    color: #29cc97;
}

.status-text-danger {
    color: red;
}

.formPosition {
    position: relative;
}

.btn-position {
    position: absolute;
    bottom: 0;
    right: 12px;
}

.store_url {
    cursor: pointer;
    /* border-bottom: 1px solid; */
}

.store_url:hover {
    color: #00a4bb;
}`, "",{"version":3,"sources":["webpack://./src/Components/Account/StoreProfile/StoreProfile/StoreProfile.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".profileTitle {\n    font-weight: 500;\n}\n\n.status-text-success {\n    color: #29cc97;\n}\n\n.status-text-danger {\n    color: red;\n}\n\n.formPosition {\n    position: relative;\n}\n\n.btn-position {\n    position: absolute;\n    bottom: 0;\n    right: 12px;\n}\n\n.store_url {\n    cursor: pointer;\n    /* border-bottom: 1px solid; */\n}\n\n.store_url:hover {\n    color: #00a4bb;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
